// 最小年份
export const MIN_YEAR = 1970;

export default {
  MIN_YEAR,
};
